<ion-app style="max-width: 1300px; margin:0 auto;">

  <ion-header *ngIf="apiService.currentUserValue?.id"  class="inapp"  style="background-color: #fff; " ><!---->
    <!-- <ion-progress-bar style="position: absolute;width:100%;top:0px;z-index:10000" *ngIf="apiService.global_loading"  type="indeterminate"></ion-progress-bar> -->
  
    <ion-toolbar>
      <ion-buttons slot="start" >
        <ion-button (click)="toggleMenu()">
          <ion-icon name="menu" slot="icon-only"> </ion-icon>
        </ion-button>
      </ion-buttons>
    <ion-row >
      <ion-col size=8 class="flexcenterleft" [routerLink]="['/']" routerLinkActive="router-link-active"  > <!--  (click)="isPopoverOpen=!isPopoverOpen"-->
      <!-- <img _ngcontent-emv-c133="" src="/assets/plus-logo.png" class="cursor" style="border-right: 1px solid #888; padding-right: 7px;"> -->
      <!----><img _ngcontent-emv-c133="" class="cursor" style="height:30px;" src="/assets/plus-logo.png"> &nbsp;
      <ion-badge  *ngIf="apiService.portal_url.includes('dev')" color="danger">Staging Instance</ion-badge>

    </ion-col>
    <!-- <ion-col size="4" *ngIf="helperService.isDevInstance()" class="ion-text-end" style="margin: auto;">
      <span  style="width: 70px;height: 60px;padding: 20px;background-color:yellow;color: black;font-weight: bold;">Staging Instance</span>
    </ion-col> -->
    <!-- <ion-col size=4 class="ion-text-end "  >
      <div class="flexcentercenter useractions" style="float: right;">
     <span [title]="apiService.currentUserValue?.email"><b>{{apiService.currentUserValue?.name}} - {{apiService.currentUserValue?.role?.name}}</b> </span> &nbsp;
     <ion-button color=light size="small" title="Change Password" (click)="show_change_password=true"><ion-icon name="key-outline"></ion-icon></ion-button> &nbsp;
     <ion-button color=light size="small" title="Logout" (click)="logout()"><ion-icon name="log-out-outline"></ion-icon></ion-button>
    </div>
    </ion-col> -->
    <ion-col size="4" class="ion-text-end">
      <div class="flexcentercenter " style="float: right; position: relative;">
        <span class="useractions" [title]="apiService.currentUserValue?.email"><b>{{apiService.currentUserValue?.v1_data?.name}} - {{apiService.currentUserValue?.v1_data?.role?.name}}</b> </span> &nbsp;

       <!-- User Icon -->
       <ion-button fill="clear" (click)="toggleDropdown()">
        <ion-icon name="person-circle-outline" size="large"></ion-icon>
      </ion-button>
    
       
      </div>
       
    </ion-col>
    
    </ion-row>
  
  
      </ion-toolbar>
      </ion-header>

 <!-- Dropdown Menu -->
 <div #dropdownMenu *ngIf="showDropdown" class="user-dropdown">
  <ion-list>
    <ion-item button  (click)="openChangePassword()">
      <ion-icon name="key-outline" slot="start"></ion-icon>
      Change Password
    </ion-item>
    <ion-item button (click)="toggleSubMenu()" style="font-size: 12px;font-weight: 600;">
      Switch Account
      <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
    </ion-item>
    <ion-item button (click)="logout()">
      <ion-icon name="log-out-outline" slot="start"></ion-icon>
      Log Out
    </ion-item>
  </ion-list>
</div>

<div *ngIf="isSubMenuOpen" 
     class="menu-dropdown" 
     style="position: absolute; top: 50px; right: 0; background: white; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); border-radius: 8px; z-index: 2000; width: 250px; padding: 10px 0;">
  
  <ion-list style="margin: 0; padding: 0;">
    <!-- Back to Main Menu -->
    <ion-item button (click)="toggleSubMenu()" style="font-size: 12px;font-weight: 600;">
      <ion-icon name="chevron-back-outline" slot="start"></ion-icon>
      Back
    </ion-item>

    <!-- Other Accounts -->
    <ion-item
      button
      *ngFor="let user of userAccounts"
      (click)="switchAccount(user)"
      [class.active-switch-account]="isCurrentActiveAccount(user)"
    >
      <ion-label>
        <p style="font-size: 12px;font-weight: 600;">{{ user.name }}<span *ngIf="user.is_primary==1" style="font-size: 11px;color: #003566;"> (Primary)</span></p>
        <p style="font-size: 11px;color: #003566;font-weight: 600;">
          {{ user?.role?.name }}<ng-container *ngIf="user?.region_ids_info && user.region_ids_info.length > 0 && user.region_ids_info[0]?.displayname"> ({{ user.region_ids_info[0].displayname }})</ng-container>
        </p>
      </ion-label>
      
    
    </ion-item>
  </ion-list>
</div>
  <ion-split-pane contentId="main-content" style="margin-top: 58px;">
    <!-- <ion-progress-bar type="indeterminate" color="primary" style="z-index: 1000;" *ngIf="apiService.global_loading"></ion-progress-bar> -->

    <ion-menu contentId="main-content" class="inapp" type="overlay" *ngIf="apiService.currentUserValue"  >
      <ion-content>
       
          <ng-container *ngFor="let asideItems of MENUITEMS" >
            <ion-list id="inbox-list">
                <ion-list-header>{{ asideItems.label |titlecase}}</ion-list-header>

                <ion-menu-toggle auto-hide="false" *ngFor="let asideItem of asideItems.main ">
                 <!-- asideItem.main_state-->
                  <ion-item routerDirection="root" *ngIf="can_show_submenu(asideItem)" [routerLink]="getRouterLink(asideItem.state)" lines="none" detail="false" routerLinkActive="selected">
                    <a
                      [href]="getRouterLink(asideItem.state)"
                      style="display: flex; align-items: center; width: 100%; text-decoration: none; color: inherit;margin: 10px 0px;"
                    >
                      <ion-icon aria-hidden="true" slot="start" [ios]="asideItem.icon + '-outline'" [md]="asideItem.icon + '-sharp'"></ion-icon>
                      <ion-label>{{ asideItem.name }}</ion-label>
                    </a>
                  </ion-item> 
                    
                </ion-menu-toggle>


              
                

              </ion-list>
          </ng-container>

     
          <ion-list id="inbox-list">
              <!-- add logout-->
              <ion-item lines="none" detail="false" (click)="logout()" routerLinkActive="selected">
                <ion-icon aria-hidden="true" slot="start" name="log-out-outline"></ion-icon>
                <ion-label>Logout</ion-label>
              </ion-item>
              </ion-list>

              <div style="padding:10px">
             
                <p class="text-center"> For Technical Support :<br>
                Mail : <a href="mailto:support@mobify.bz">support&#64;mobify.bz</a><br><br>
              </p></div>
                <hr>
                
      </ion-content>
    </ion-menu>
    
    <ion-router-outlet id="main-content"></ion-router-outlet>
      <!-- Show toast when offline -->

<!-- 
    <div style="position: absolute;z-index:100;padding:5px;" *ngIf="apiService.currentUserValue?.id">
      <ion-menu-toggle>
      <ion-button size="small" fill="outline">
        <ion-icon name="menu-outline"></ion-icon>
      </ion-button>
    </ion-menu-toggle>
    </div> -->

   


  </ion-split-pane>
</ion-app>

<ion-modal [isOpen]="show_change_password" (didDismiss)="show_change_password=false">
  <ng-template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot=start>
        <ion-back-button></ion-back-button>
      </ion-buttons>
      <ion-title style="padding-inline-start: 0px;">
        <!-- <span *ngIf="!model?._id">Add</span> -->
        <span>Change Password</span>
      </ion-title>
      <ion-buttons slot=end>
         <ion-button (click)="show_change_password=false"><ion-icon name="close-outline"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  
  <ion-content>
  
    <form (ngSubmit)="formSubmitChangePassword($event)"  ngNativeValidate>
      <ion-row>
  
  
        
  
          <ion-col size="12" size-sm="12">
           
              <ion-label position="floating">New Password</ion-label>
              <ion-input fill="outline" type=password name=newPassword [(ngModel)]="model.npassword" required> </ion-input>
           
        </ion-col>


        <ion-col size="12" size-sm="12">
           
          <ion-label position="floating">Confirm Password</ion-label>
          <ion-input fill="outline" type=text name=newPassword [(ngModel)]="model.confirm_password" required> </ion-input>
       
    </ion-col>
      </ion-row>
  
      <hr>
      <ion-row>
        <ion-col size=6><ion-button (click)="show_change_password=false" color=light expand=block>Cancel</ion-button></ion-col>
        <ion-col size=6><ion-button type=submit expand=block>Save  <ion-spinner *ngIf="loadingcp" name="lines-small"></ion-spinner></ion-button></ion-col>
      </ion-row>
    </form>
  
  </ion-content>
</ng-template>
</ion-modal>